$(function() {

	var slideshows = {

		init: function() {
			//home slideshow
			$('[slideshow-full]').slick({
				arrows: false,
				dots: true,
				autoplay: true
			});

			//content slideshow

			$('[slideshow-center]').each(function() {
				var slick = $(this),
					initialSlide = $(this).data('initial-slide');

				slick.slick({
					arrows: false,
					dots: false,
					centerMode: true,
					infinite: false,
					slidesToShow: 2,
					initialSlide: initialSlide ? initialSlide : 1,
					responsive: [{
						breakpoint: 1104,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}]
				});
			});
		}
	}
	slideshows.init();
});